import { render, staticRenderFns } from "./CouponCarousel.vue?vue&type=template&id=2425a979&scoped=true&"
import script from "./CouponCarousel.vue?vue&type=script&lang=js&"
export * from "./CouponCarousel.vue?vue&type=script&lang=js&"
import style0 from "./CouponCarousel.vue?vue&type=style&index=0&id=2425a979&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2425a979",
  null
  
)

export default component.exports